export default ({ color = '#fcfcfc', className, style }) => (
  <svg width="106.595" height="38" viewBox="0 0 106.595 38" className={className} style={style}>
    <path
      d="M-161.464,16065.064l-2.023,2.477-20.615-4.234s-24.838-4.984-2.984-5.479c17.481-.4,25.031-7.328,27.355-10.088a20.187,20.187,0,0,1,16.791-8.74,20.239,20.239,0,0,1,16.128,7.824l.135-.205s6.337,10.709,28.191,11.209-2.978,5.479-2.978,5.479l-20.615,4.234-2.236-2.736a19.942,19.942,0,0,1-18.625,12.2A19.968,19.968,0,0,1-161.464,16065.064Z"
      transform="translate(196.082 -16039)"
      fill={color}
    />
  </svg>
)
